import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import InputField from "../../../jsx/components/fields/inputField";
import PrimaryButton from "../../../jsx/components/button/primaryButton";
import {
  emailValidation,
  noSpaceOnChange,
  phoneOnChange,
  phoneValidation,
  firstNameValidation,
} from "../../../functions/validations";
import { useNavigate, useLocation } from "react-router-dom";
import PhonenumberField from "../../../jsx/components/fields/phoneFields";
import ResponceToaster from "../../../jsx/components/responceToaster/responceToaster";
import html2canvas from "html2canvas";
import TextArea from "../fields/textArea";
import sendOverallFeedback from "../../../service/api/user/sendOverallFeedback";
import { BiStar } from "react-icons/bi";
import { BsStarFill } from "react-icons/bs";

const FeedbackModal = ({ addUserTrigger, handleCloseAddUser }) => {
  const { role, userName, phoneCodeRedux, phoneNumberRedux, emailRedux } =
    useSelector((state) => state.user);

  const newH = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [userAuthorized, setUserAuthorized] = useState(false);

  const { authorized } = useSelector((state) => state.auth);
  const [firstName, setFirstName] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [isLastNameError, setIsLastNameError] = useState(false);
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isEmailError, setIsEmailError] = useState(false);
  const [phonenumber, setPhonenumber] = useState();
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [countryCode, setCountryCode] = useState(0);
  const [roleUser, setRoleUser] = useState("2");
  const [loaderActive, setLoaderActive] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [resMessage, setResMessage] = useState("");
  const [feedBackMsg, setFeedBackMsg] = useState("");
  const [isFeedBackError, setIsFeedBackError] = useState(false);
  const [image, setImage] = useState();
  const [browserName, setBrowserName] = useState("");
  const [platform, setPlatform] = useState("");
  const [pageDetails, setPageDetails] = useState("");

  const [ratingValue, setRatingValue] = useState(5);

  const handleRole = (e) => {
    setRoleUser(e.target.value);
  };
  const handleFirstName = (e) => {
    setIsFirstNameError(false);
    setFirstName(e.target.value);
  };
  const handleLastName = (e) => {
    setIsLastNameError(false);
    setLastName(e.target.value);
  };

  const handleEmail = (e) => {
    setIsEmailError(false);
    setIsPhoneError(false);
    noSpaceOnChange(e.target.value) && setEmail(e.target.value);
  };

  const handlePhonenumber = (e) => {
    setIsPhoneError(false);
    setIsEmailError(false);
    phoneOnChange(e.target.value) && setPhonenumber(e.target.value);
  };

  const handleCountryCode = (e, v) => {
    setCountryCode(v.country_id_ids);
  };

  function handleFirstNameBlurCheck() {
    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true);
    }
  }
  function handleLastNameBlurCheck() {
    if (lastName.trim().length > 0) {
      if (!firstNameValidation(lastName)) {
        setIsLastNameError(true);
      }
    }
  }
  function handleEmailBlurCheck() {
    if (!emailValidation(email)) {
      setIsEmailError(true);
    }
  }

  function handlePhonenumberBlurCheck() {
    if (!phoneValidation(phonenumber)) {
      setIsPhoneError(true);
    }
  }

  function onChangeFeedBackMsg(e) {
    setIsFeedBackError(false);
    setFeedBackMsg(e.target.value);
  }
  const [showImg, setShowImg] = useState(null);
  useEffect(() => {
    html2canvas(document.getElementById("app"))
      .then((canvas) => {
        canvas.style.display = "none";
        document.body.appendChild(canvas);
        return canvas;
      })
      .then((canvas) => {
        const showImage = canvas.toDataURL("image/png");
        setShowImg(showImage);

        const image = canvas
          .toDataURL("image/png")
          .replace("data:", "")
          .replace(/^.+,/, "");

        const byteCharacters = atob(image);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray]);
        const newblob = blob.slice(0, blob.size, "image/png");
        //  console.log(newblob,"bne")
        setImage(newblob);
      });

    let userAgent;

    if (window.navigator && window.navigator.userAgent) {
      userAgent = window.navigator.userAgent;

      if (userAgent) {
        let browserName;

        if (userAgent.match(/chrome|chromium|crios/i)) {
          browserName = "chrome";
        } else if (userAgent.match(/firefox|fxios/i)) {
          browserName = "firefox";
        } else if (userAgent.match(/safari/i)) {
          browserName = "safari";
        } else if (userAgent.match(/opr\//i)) {
          browserName = "opera";
        } else if (userAgent.match(/edg/i)) {
          browserName = "edge";
        } else {
          browserName = "No browser detection";
        }
        setBrowserName(browserName);
      }
    } else {
    }

    // let userAgent = window.navigator.userAgent;
    let browserName;

    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = "chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = "firefox";
    } else if (userAgent.match(/safari/i)) {
      browserName = "safari";
    } else if (userAgent.match(/opr\//i)) {
      browserName = "opera";
    } else if (userAgent.match(/edg/i)) {
      browserName = "edge";
    } else {
      browserName = "No browser detection";
    }
    setBrowserName(browserName);

    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    let type;
    let keyVal;

    type = toMatch.some((toMatchItem, key) => {
      keyVal = key;
      return window.navigator.userAgent.match(toMatchItem);
    });

    setPlatform(toMatch[keyVal] + " Browser");

    if (newH.pathname !== "/") {
      setPageDetails(newH.pathname);
    } else {
      setPageDetails("Dashboard");
    }
  }, []);

  function submitFeedback() {
    let formData = new FormData();

    if (isAnonymous || !authorized) {
      if (feedBackMsg.trim() != "") {
        setLoaderActive(true);
        formData.append("full_name_chr", "");
        formData.append("email_chr", " ");
        formData.append("phone_code_id_int", 0);
        formData.append("phone_number_int", 0);
        formData.append("role_id_int", role);
        formData.append("page_details_chr", pageDetails);
        formData.append("operating_system_details_chr", browserName);
        formData.append("platform_chr", platform);
        formData.append("app_version_chr", " ");
        formData.append("api_version_chr", "/v1");
        formData.append("feedback_message_chr", feedBackMsg);
        formData.append("attachment", image, "feedback.png");
        formData.append("is_anonymous_ysn", 1);
        formData.append("rating_value_int", ratingValue);

        dispatch(
          sendOverallFeedback(
            formData,
            (res) => {
              setLoaderActive(false);
              setFeedBackMsg("");
              setIsAnonymous(false);
              setToasterType("success");
              setResMessage(res.data.message);
              handleCloseAddUser("success", res.data.message);
            },
            (res) => {
              setToasterType("error");
              setResMessage(res.data.message);
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
              setLoaderActive(false);
            }
          )
        );
      } else {
        setIsFeedBackError(true);
      }
    } else {


      if (feedBackMsg.trim() != "") {
        setLoaderActive(true);
        formData.append(
          "full_name_chr",
          localStorage.getItem("fullName") || `${firstName} ${lastName}`
        );
        formData.append("email_chr", emailRedux || email);
        formData.append("phone_code_id_int", phoneCodeRedux || countryCode);
        formData.append(
          "phone_number_int",
          phoneNumberRedux || phonenumber || 0
        );
        formData.append("role_id_int", role || 0);
        formData.append("page_details_chr", pageDetails || "");
        formData.append("operating_system_details_chr", platform || "");
        formData.append("platform_chr", browserName || "");
        formData.append("app_version_chr", "web");
        formData.append("api_version_chr", "/v1");
        formData.append("feedback_message_chr", feedBackMsg || "");
        formData.append("attachment", image, "feedback.png");
        formData.append("is_anonymous_ysn", 0);

        dispatch(
          sendOverallFeedback(
            formData,
            (res) => {
              setFeedBackMsg("");
              setIsAnonymous(false);
              setLoaderActive(false);
              console.log(res.data.message, "Mesage");
              handleCloseAddUser("success", res.data.message);
              setToasterType("success");

              setResMessage(res.data.message);
            },
            (res) => {
              setToasterType("error");
              setResMessage(res.data.message);
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
              setLoaderActive(false);
            }
          )
        );
      } else {
        setIsFeedBackError(true);
      }

    }
  }

  const checkHW = useRef(null);
  const [imgMaxHeight, setImgMaxHeight] = useState(0);
  const [imgMaxWidth, setImgMaxWidth] = useState(0);
  const [hover, setHover] = useState(0);

  useEffect(() => {
    const height = checkHW.current.getBoundingClientRect().height;
    const width = checkHW.current.getBoundingClientRect().width;
    setImgMaxWidth(width);
    setImgMaxHeight(height);
  }, []);
  return (
    <>
      {/* <!-- Modal --> */}

      {
        <>
          <Modal className="fade" size="lg" show={true} centered >
            <div className="row p-3" style={{ maxHeight: '580px' }}>
              <div className="col-6 d-flex justify-content-center ">
                <div
                  className="col-12 px-0"
                  ref={checkHW}
                  style={{ background: "#AAAAAA", position: "relative" }}>
                  <img
                    alt=""
                    className="d-flex justify-content-center"
                    src={showImg}
                    style={{
                      maxWidth: imgMaxWidth + "px",
                      maxHeight: imgMaxHeight + "px",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                  <span
                    style={{ position: "absolute", top: "6px", left: "6px" }}>
                    <span
                      className="fs-7 px-2 py-1 w-100"
                      style={{
                        color: "grey",
                        background: "white",
                        borderRadius: "20px",
                      }}>
                      Screenshot{" "}
                    </span>
                  </span>
                </div>
              </div>
              <div className="col-6">
                <div
                  className=" px-0 h-100"
                  style={{ display: "flex", flexDirection: "column" }}>
                  <div className="py-2 px-3">
                    <div className="m-0 row">
                      <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                        <span className="">
                          <i className="bi bi-x-lg cursor-pointer" onClick={handleCloseAddUser}></i>
                        </span>
                      </div>
                    </div>

                    <div className="mx-0 row ">
                      <span className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                        Feedback
                      </span>
                    </div>
                    <div className="mx-0 row mt-3">
                      <span className=" fs-6 px-0 text-center text-gray text-center">
                        Please share your feedback with us. We'd love to hear
                        from you with any thoughts and suggestions you have
                        about any screen of the Chilll web app.
                      </span>
                    </div>
                  </div>
                  <div
                    className="row mx-0 mt-2"
                    style={{ flex: "1", alignItems: "end" }}>
                    <div className="row px-3" style={{ minHeight: "220px" }}>
                      <div className="col-12 px-0 fs-7  mb-2">
                        <div className="row m-1">
                          <div className="row mx-0">
                            <div className="col-6 d-flex justify-content-start align-items-center fs-7"></div>
                            <div className="col-6 d-flex justify-content-end align-items-center fs-7"></div>
                          </div>
                          <div className="row mx-0">
                            <div
                              className="col-12 d-flex justify-content-start align-items-center fs-6 pt-3"
                            >
                              <div className="col-12 px-0 text-center  ">
                                {/* May be create a separate component for this rating */}
                                <div
                                  className="font-w600 fs-3 mb-3"
                                  style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                  {[...Array(5)].map((star, i) => {
                                    const rating = i + 1;
                                    return (
                                      <label key={i}>
                                        <input
                                          type="radio"
                                          name="rating"
                                          value={ratingValue}
                                          onClick={(e) => {
                                            setRatingValue(rating);
                                          }}
                                          style={{ display: "none" }}
                                        />
                                        {rating <= (hover || ratingValue) ? (
                                          <BsStarFill
                                            onMouseEnter={() => setHover(rating)}
                                            onMouseLeave={() => setHover(0)}
                                            className="star"
                                            style={{
                                              width: "24px",
                                              height: "24px",
                                              cursor: "pointer",
                                              color: "gold",
                                            }}
                                          />
                                        ) : (
                                          <BiStar
                                            onMouseEnter={() => setHover(rating)}
                                            onMouseLeave={() => setHover(0)}
                                            className="star"
                                            style={{
                                              width: "24px",
                                              height: "24px",
                                              cursor: "pointer",
                                              color: "gray",
                                            }}
                                          />
                                        )}
                                      </label>
                                    );
                                  })} &nbsp;&nbsp; <span className="fs-6 ">{"("}{`${ratingValue} of 5`}{")"}</span>
                                </div>

                                <div>
                                  <TextArea onChange={onChangeFeedBackMsg}
                                    value={feedBackMsg}
                                    labelName={"Your feedback"}
                                    errorMessage={"Please enter message"}
                                    errorOccured={isFeedBackError}
                                  />
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row px-3">
                      <PrimaryButton
                        buttonName={"SEND FEEDBACK"}
                        isLoading={loaderActive}
                        loadingMessage={"SENDING..."}
                        style={{
                          width: '100%',
                          border: 'none',
                          background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                          boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                        }}
                        onClick={submitFeedback}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </>
      }

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={resMessage} />
      )}
    </>
  );
};

export default FeedbackModal;

// <Modal
// className="fade"
// show={addUserTrigger}
// // onHide={handleCloseAddUser}
// >
// <Modal.Header style={{ borderBottom: "none" }}>
//   <Modal.Title>Feedback</Modal.Title>
//   {/* <PrimaryButton onClick={handleCloseAddUser} buttonName={"Close"} /> */}
//   <img  src={showImg}/>
//   <Button
//     variant=""
//     className="btn-close btn-close-service"
//     onClick={() => handleCloseAddUser()}
//   ></Button>
// </Modal.Header>

{
  /* <Modal.Body>
  {!authorized && !isAnonymous && 
    <>
      {" "} */
}
{
  /* <div style={{display:'flex',justifyContent:'space-between'}}>
      
      <div>
      <InputField
        labelName={"First Name"}
        placeholderName={"First name"}
        onChange={handleFirstName}
        onBlur={handleFirstNameBlurCheck}
        errorOccured={isFirstNameError}
        errorMeesage={"invalid firstname"}
        value={firstName}
      />
      </div>
    <div>
    <InputField
        labelName={"Last Name"}
        placeholderName={"Last name"}
        onChange={handleLastName}
        onBlur={handleLastNameBlurCheck}
        value={lastName}
        errorOccured={isFirstNameError}
      />
    </div> */
}
{
  /* </div>
      <InputField
        labelName={"Email"}
        placeholderName={"Enter email"}
        onChange={handleEmail}
        errorMeesage={"invalid email"}
        errorOccured={isEmailError}
        onBlur={handleEmailBlurCheck}
      />
      <PhonenumberField
        handleInputValue={handlePhonenumber}
        errorOccured={isPhoneError}
        errorMeesage={"invalid phone number"}
        inputValue={phonenumber}
        handleChangeCode={handleCountryCode}
        handleOnBlur={handlePhonenumberBlurCheck}
      />
    </>

  } */
}

{
  /* <TextArea
    onChange={onChangeFeedBackMsg}
    value={feedBackMsg}
    labelName={"Message"}
    errorMessage={"Please enter some text"}
    errorOccured={isFeedBackError}
  />

  <Form.Check
    aria-label="option 1"
    label="Send as anonymous"
    checked={isAnonymous}
    onClick={() => {
      setIsAnonymous(!isAnonymous);
    }}
  />
  <div className="d-flex align-items-center justify-content-end">
    <PrimaryButton
      buttonName={"Send Feedback"}
      isLoading={loaderActive}
      loadingMessage={"Sending..."}
      onClick={submitFeedback}
    />
  </div>
</Modal.Body>
</Modal> */
}
